import DetectRTC from 'detectrtc';
import { StreemApiDeviceSupportedVideoPlatforms } from '@streem/api';
import { logger } from './logger';
export function determineSupportedVideoPlatforms() {
    const supportedPlatforms = [
        StreemApiDeviceSupportedVideoPlatforms.ARAAS,
        StreemApiDeviceSupportedVideoPlatforms.CHIME,
    ];
    // https://github.com/muaz-khan/DetectRTC/blob/master/DetectRTC.js#L879-L890
    if (!DetectRTC.isWebRTCSupported) {
        logger.warn('User is on a browser that does not support WebRTC: ', DetectRTC.browser.fullVersion);
    }
    return supportedPlatforms;
}
//# sourceMappingURL=determine_supported_video_platforms.js.map